<plat-top-menu *ngIf="showTopBar$ | async">
	<div class="switch-group">
		<checkbox
			*ngIf="!(hideXenaNeoSwitch$ | async)"
			[ngModel]="(showNeoFrame$ | async)"
			[uncheckedLabel]="routeFrom"
			(ngModelChange)="closeNeoFrame($event)"
			[label]="routeTo"
			type="switch"
		></checkbox>
	</div>
</plat-top-menu>

<iframe [src]="neoUrl$ | async" #neoFrame *ngIf="(neoUrl$ | async)"></iframe>



// WEBPACK FOOTER //
// ./src/app/neo-frame/neo-frame.component.html